import g from './utils/globalVariables.es6';
import getTargetElement from './utils/getTargetElement.es6';

const CLOSE_SEARCH_SELECTOR = '.js-search-close';


const init = () => {
  g.$document
    .off('.toggleModalSearch')
    .on('click.toggleModalSearch', CLOSE_SEARCH_SELECTOR, closeSearch);
};

const closeSearch = (event) => {
  let $trigger = $(event.currentTarget);
  let $target = getTargetElement($trigger);

  if ($target.length === 0) {
    return false;
  }

  $target.collapse('hide');
};

export default init;
